export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/account/login.vue'),
    meta: {
      title: 'Login'
      /*beforeResolve() {
        localStorage.clear();
      },*/
    }
  },
  {
    path: '/dashboard/general',
    name: 'Dashboard Water Quality',
    meta: {
      title: 'Water Quality Dashboard',
      authRequired: true
    },
    component: () => import('../views/dashboard/general/index.vue')
  },
  {
    path: '/dashboard/performance',
    name: 'Performance variables',
    meta: {
      title: 'Performance Dashboard',
      authRequired: true
    },
    component: () => import('../views/dashboard/performance/index.vue')
  },
  {
    path: '/admin/users',
    name: 'Users',
    meta: { title: 'Users', authRequired: true },
    component: () => import('../views/pages/admin/users')
  },
  {
    path: '/admin/users/roles',
    name: 'Users Roles',
    meta: { title: 'User Role', authRequired: true },
    component: () => import('../views/pages/admin/roles')
  },
  {
    path: '/admin/producers',
    name: 'Producers',
    meta: { title: 'Producers', authRequired: true },
    component: () => import('../views/pages/admin/producers')
  },
  {
    path: '/admin/farms',
    name: 'Farms',
    meta: { title: 'Farms', authRequired: true },
    component: () => import('../views/pages/admin/farms')
  },
  {
    path: '/admin/farms/:farmId/modules',
    name: 'Modules',
    meta: { title: 'Modules', authRequired: true },
    component: () => import('../views/pages/admin/farms-modules')
  },
  {
    path: '/admin/farms/:farmId/bluewhales',
    name: 'BlueWhales',
    meta: { title: 'BlueWhales', authRequired: true },
    component: () => import('../views/pages/admin/farms-bluewhales')
  },
  {
    path: '/admin/farms/:farmId/containers',
    name: 'Containers',
    meta: { title: 'Containers', authRequired: true },
    component: () => import('../views/pages/admin/farms-containers')
  },
  {
    path: '/admin/animals-type',
    name: 'Animals Type',
    meta: { title: 'Animals', authRequired: true },
    component: () => import('../views/pages/admin/animals-type')
  },
  {
    path: '/admin/animals',
    name: 'Genetics',
    meta: { title: 'Genetics', authRequired: true },
    component: () => import('../views/pages/admin/animals-species')
  },
  {
    path: '/admin/animals/:animalId/curve',
    name: 'Genetics Growth curve',
    meta: { title: 'Genetics Growth curve', authRequired: true },
    component: () => import('../views/pages/admin/animals-curve')
  },
  {
    path: '/admin/animals/generations',
    name: 'Genetics Generations',
    meta: { title: 'Genetics Generations', authRequired: true },
    component: () => import('../views/pages/admin/animals-generations')
  },
  {
    path: '/admin/animals/populations',
    name: 'Genetics Populations',
    meta: { title: 'Genetics Populations', authRequired: true },
    component: () => import('../views/pages/admin/animals-populations')
  },
  {
    path: '/admin/animals/active-populations',
    name: 'Active Populations',
    meta: { title: 'Active Populations', authRequired: true },
    component: () => import('../views/pages/admin/active-populations')
  },
  {
    path: '/admin/population/:populationId/summary',
    name: 'Pupulation Summary',
    meta: { title: 'Pupulation Summary', authRequired: true },
    component: () => import('../views/pages/admin/population-summary')
  },
  {
    path: '/admin/strategies',
    name: 'Feed Strategies',
    meta: { title: 'Feed Strategies', authRequired: true },
    component: () => import('../views/pages/admin/feed-strategies')
  },
  {
    path: '/admin/strategies/:statregyId/stage',
    name: 'Feed Strategies Stage',
    meta: { title: 'Feed Strategies Stage', authRequired: true },
    component: () => import('../views/pages/admin/feed-strategies-stage')
  },
  {
    path: '/',
    name: 'Tasks',
    meta: { title: 'Tasks', authRequired: true },
    component: () => import('../views/pages/admin/tasks')
  },
  {
    path: '/admin/tasks-manual',
    name: 'Tasks Manual',
    meta: { title: 'Tasks Manual', authRequired: true },
    component: () => import('../views/pages/admin/tasks-manual')
  },
  {
    path: '/admin/tasks-edit',
    name: 'Tasks Edit',
    meta: { title: 'Tasks Edit', authRequired: true },
    component: () => import('../views/pages/admin/tasks-edit')
  },
  {
    path: '/admin/weekly-programming',
    name: 'Weekly Programming',
    meta: { title: 'Weekly Programming', authRequired: true },
    component: () => import('../views/pages/admin/weekly-programming')
  },
  {
    path: '/admin/devices',
    name: 'Devices',
    meta: { title: 'Devices', authRequired: true },
    component: () => import('../views/pages/admin/devices')
  },
  {
    path: '/admin/devices/:deviceId/configuration',
    name: 'Devices Configuration',
    meta: { title: 'Devices Configuration', authRequired: true },
    component: () => import('../views/pages/admin/devices-configuration')
  },
  {
    path: '/reports/water-quality',
    name: 'Water Quality',
    meta: { title: 'Water Quality', authRequired: true },
    component: () => import('../views/pages/water-quality')
  },
  {
    path: '/reports/weekly-summary',
    name: 'Weekly Summary',
    meta: { title: 'Weekly Summary', authRequired: true },
    component: () => import('../views/pages/admin/weekly-summary')
  },
  {
    path: '/reports/time-by-task',
    name: 'Time by Task',
    meta: { title: 'Time by Task', authRequired: true },
    component: () => import('../views/pages/time-by-task')
  },
  {
    path: '/reports/weekly-task-report-app',
    name: 'Weekly Task Report App',
    meta: { title: 'Weekly Task Report App', authRequired: true },
    component: () => import('../views/pages/admin/weekly-task-report-app')
  },
  {
    path: '/reports/weekly-animal-health-report',
    name: 'Weekly Animal Health Report',
    meta: { title: 'Weekly Animal Health Report', authRequired: true },
    component: () => import('../views/pages/admin/weekly-animal-health-report')
  },
  {
    path: '/reports/weekly-waste-report',
    name: 'Waste Report',
    meta: { title: 'Waste Report', authRequired: true },
    component: () => import('../views/pages/admin/weekly-waste-report')
  },
  {
    path: '/reports/inventory-report',
    name: 'Inventory Report',
    meta: { title: 'Inventory Report', authRequired: true },
    component: () => import('../views/pages/admin/inventory-report.vue')
  },
  {
    path: '/reports/inventory-deviation-report',
    name: 'Inventory Deviation Report',
    meta: { title: 'Inventory Deviation Report', authRequired: true },
    component: () =>
      import('../views/pages/admin/inventory-deviation-report.vue')
  },
  {
    path: '/reports/zootechnician-report',
    name: 'Zootechnician Report',
    meta: { title: 'Zootechnician Report', authRequired: true },
    component: () =>
      import('../views/pages/admin/weekly-zootechnician-report.vue')
  },
  {
    path: '/reports/feeding-report',
    name: 'Feeding Report',
    meta: { title: 'Feeding Report', authRequired: true },
    component: () => import('../views/pages/admin/weekly-feeding-report.vue')
  },
  {
    path: '/reports/water-quality-report',
    name: 'Water Quality Report',
    meta: { title: 'Water Quality Report', authRequired: true },
    component: () =>
      import('../views/pages/admin/weekly-water-quality-report.vue')
  },
  {
    path: '/reports/weekly-biomass-report',
    name: 'Biomass Report',
    meta: { title: 'Biomass Report', authRequired: true },
    component: () => import('../views/pages/admin/weekly-biomass-report')
  },
  {
    path: '/reports/weekly-vibrios-report',
    name: 'Vibrios Report',
    meta: { title: 'Vibrios Report', authRequired: true },
    component: () => import('../views/pages/admin/weekly-vibrios-report')
  },
  {
    path: '/reports/harvest-report',
    name: 'Harvest Report',
    meta: { title: 'Harvest Report', authRequired: true },
    component: () => import('../views/pages/admin/weekly-harvest-report.vue')
  },
  {
    path: '/reports/additives-report',
    name: 'Additives Report',
    meta: { title: 'Additives Report', authRequired: true },
    component: () => import('../views/pages/admin/weekly-additives-report.vue')
  },
  {
    path: '/operations/calendar',
    name: 'calendar',
    meta: { title: 'Calendar', authRequired: true },
    component: () => import('../views/calendar/index')
  },
  {
    path: '/operations/manual-report',
    name: 'Manual Report',
    meta: { title: 'Manual Report', authRequired: true },
    component: () => import('../views/pages/manual-report')
  },
  {
    path: '/admin/inventory/warehouses',
    name: 'Inventory',
    meta: { title: 'Inventory', authRequired: true },
    component: () => import('../views/pages/admin/warehouses')
  },
  {
    path: '/admin/inventory/unit-measures',
    name: 'Unit Measures',
    meta: { title: 'Unit Measures', authRequired: true },
    component: () => import('../views/pages/admin/unit-measures')
  },
  {
    path: '/admin/inventory/category-items',
    name: 'Category Items',
    meta: { title: 'Category Items', authRequired: true },
    component: () => import('../views/pages/admin/category-items')
  },
  {
    path: '/admin/inventory/items',
    name: 'Items',
    meta: { title: 'Items', authRequired: true },
    component: () => import('../views/pages/admin/items')
  },
  {
    path: '/admin/inventory/stocks',
    name: 'Stocks',
    meta: { title: 'Stocks', authRequired: true },
    component: () => import('../views/pages/admin/stocks')
  },
  {
    path: '/admin/inventory/entrances',
    name: 'Entrances',
    meta: { title: 'Entrances', authRequired: true },
    component: () => import('../views/pages/admin/entrances')
  },
  {
    path: '/admin/inventory/exits',
    name: 'Exits',
    meta: { title: 'Exits', authRequired: true },
    component: () => import('../views/pages/admin/exits')
  },
  {
    path: '/admin/inventory/physical',
    name: 'Inventory Physical',
    meta: { title: 'Inventory Physical', authRequired: true },
    component: () => import('../views/pages/admin/physical-inventory')
  },
  {
    path: '/admin/inventory/physical/audit',
    name: 'Inventory Physical Audit',
    meta: { title: 'Inventory Physical Audit', authRequired: true },
    component: () => import('../views/pages/admin/physical-inventory-audit')
  },
  {
    path: '/admin/marketplace',
    name: 'Marketplace',
    meta: { title: 'Marketplace', authRequired: true },
    component: () => import('../views/pages/admin/marketplace')
  },
  {
    path: '/admin/faq/shrimpbot',
    name: 'Shrimpbot',
    meta: { title: 'Shrimpbot', authRequired: true },
    component: () => import('../views/pages/admin/faq')
  },
  {
    path: '/admin/oracle/sizes',
    name: 'Commercial sizes',
    meta: { title: 'Commercial sizes', authRequired: true },
    component: () => import('../views/pages/admin/oracle-commercial-sizes')
  },
  {
    path: '/admin/oracle/projections',
    name: 'Projections',
    meta: { title: 'Projections', authRequired: true },
    component: () => import('../views/pages/admin/oracle-projections')
  },
  {
    path: '/admin/oracle/harvest',
    name: 'Harvest Projections',
    meta: { title: 'Harvest Projections', authRequired: true },
    component: () => import('../views/pages/admin/weekly-oracle-harvest')
  },
  {
    path: '/reports/ionic-balance',
    name: 'Ionic Balance',
    meta: { title: 'Ionic Balance', authRequired: true },
    component: () =>
      import('../views/pages/admin/weekly-ionic-balance-report.vue')
  },
  {
    path: '/admin/sales/playground',
    name: 'Playground',
    meta: { title: 'Playground', authRequired: true },
    component: () => import('../views/pages/admin/sales-playground.vue')
  },
  {
    path: '/sales/orders-of-week',
    name: 'Orders of week',
    meta: { title: 'Orders of week', authRequired: true },
    component: () => import('../views/pages/admin/weekly-sales-report.vue')
  },
  {
    path: '/sales/approved-orders',
    name: 'Approved orders',
    meta: { title: 'Approved orders', authRequired: true },
    component: () => import('../views/pages/admin/approve-orders.vue')
  },
  {
    path: '/reports/sales-report',
    name: 'Sales Report',
    meta: { title: 'Sales Report', authRequired: true },
    component: () => import('../views/pages/admin/sales-report.vue')
  },
  {
    path: '/admin/generation/:generationId/summary',
    name: 'Generation Summary',
    meta: { title: 'Generation Summary', authRequired: true },
    component: () => import('../views/pages/admin/generation-summary.vue')
  },
  {
    path: '/404',
    name: 'Error404',
    meta: { title: 'Página no encontrada' },
    component: () => import('../views/pages/404.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]
